module.exports = {
  "country": "BE",
  "artist": "Loïc Nottet",
  "song": "Rhythm Inside",
  "year": "2015",
  "place": "4",
  "spotify": "3O2MsMZHCgSbRGEca5ML1N"
};